export default "__VITE_ASSET__CuWP5WKV__"